// The organizer API accepts the JWT as a bearer header next to the auth cookie.
// Use this for every REST fetch instead of building the header inline.
export const authorizationHeaders = (authToken?: string | null): Record<string, string> | undefined =>
    authToken ? {Authorization: `Bearer ${authToken}`} : undefined;

export const authorizedFetchOptions = (authToken?: string | null, init: RequestInit = {}): RequestInit => ({
    credentials: "include",
    ...init,
    headers: {...authorizationHeaders(authToken), ...(init.headers as Record<string, string> | undefined)}
});
